import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ToasterPlacement } from '@coreui/angular-pro'; 

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  
  private toastSubject = new Subject<any>();
  toastState = this.toastSubject.asObservable();

  constructor() {}

  showToast(optionsfromget: any) {
    const options = {
      title: optionsfromget.title? optionsfromget.title : 'Title',
      delay: optionsfromget.delay? optionsfromget.delay : 3000,
      placement: optionsfromget.placement? optionsfromget.placement : ToasterPlacement.TopEnd,
      color: optionsfromget.color? optionsfromget.color : 'success',
      autohide: optionsfromget.autohide,
      description: optionsfromget.description? optionsfromget.description : 'Description',
      status: optionsfromget.status,
    };
    this.toastSubject.next(options);
  }
}
